import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import { Text } from '@optiro/ui';

import { NotificationType } from './notifications.types';

export function NotificationContent({ n }: { n: NotificationType }) {
  const { t } = useTranslation('notifications');

  switch (n.type) {
    case 'TaskNotifier::Notification':
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('AssignmentNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('AssignmentNotifier.message', {
              project_name: n.params.project?.name ?? '',
            })}
          </Text>
        </>
      );

    case 'ProjectStartReminderNotifier::Notification':
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('ProjectStartReminderNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('ProjectStartReminderNotifier.message', {
              project_name: n.params.project?.name ?? '',
            })}
          </Text>
        </>
      );

    case 'TimesheetRejectionNotifier::Notification':
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('TimesheetRejectionNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('TimesheetRejectionNotifier.message', {
              work_date: n.params.timesheet?.work_date ?? '',
            })}
          </Text>
        </>
      );

    case 'TimesheetApprovalNotifier::Notification':
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('TimesheetApprovalNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('TimesheetApprovalNotifier.message', {
              work_date: n.params.timesheet?.work_date ?? '',
            })}
          </Text>
        </>
      );

    case 'TimesheetReminderNotifier::Notification': {
      const weekEnding = DateTime.fromISO(n.params.week_ending).toLocaleString(DateTime.DATE_MED);
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('TimesheetReminderNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('TimesheetReminderNotifier.week_ending', {
              week_ending: weekEnding,
            })}
          </Text>
        </>
      );
    }

    case 'FeedbackNotifier::Notification':
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('FeedbackNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('FeedbackNotifier.message')}
          </Text>
        </>
      );

    case 'AccountReminderNotifier::Notification':
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('AccountReminderNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('AccountReminderNotifier.message')}
          </Text>
        </>
      );

    case 'ProjectOverdueNotifier::Notification':
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('ProjectOverdueNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('ProjectOverdueNotifier.message', {
              project_name: n.params.project?.name ?? '',
            })}
          </Text>
        </>
      );

    case 'ProjectEndReminderNotifier::Notification':
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('ProjectEndReminderNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('ProjectEndReminderNotifier.message', {
              project_name: n.params.project?.name ?? '',
            })}
          </Text>
        </>
      );

    case 'IntervalCompletionStateSubmittedNotifier::Notification':
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('IntervalCompletionStateSubmittedNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('IntervalCompletionStateSubmittedNotifier.message', {
              resource_name: n.params.resource_name,
              percentage: n.params.percentage,
              project_name: n.params.project?.name ?? '',
            })}
          </Text>
        </>
      );

    case 'IntervalCommentAddedNotifier::Notification':
      return (
        <>
          <Text size="sm" fw={n.read_at ? 400 : 600} lineClamp={1}>
            {t('IntervalCommentAddedNotifier.title')}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {t('IntervalCommentAddedNotifier.message', {
              project_name: n.params.project?.name ?? '',
            })}
          </Text>
        </>
      );
  }
}
